// Third Party
import $ from 'jquery';

export default {
  install(Vue, options) {
    // v-focus
    Vue.directive('focus', {
      inserted: function (el) {
        el.focus()
      }
    });
    Vue.directive('tooltip', function(el, binding){
			const isTouchDevice = ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
			$(el).tooltip({
				title: binding.value,
				placement: binding.arg,
				trigger: isTouchDevice ? 'click' : 'hover'
			})
		});
  }
}
